import React, { useState } from 'react';
import { Row, Radio } from 'antd';

import * as S from './styles';

export function Status({ valueStatus, todasAprovadas }) {
  const [value, setValue] = useState(null);

  const onChange = e => {
    setValue(e.target.value);
    valueStatus(e.target.value);
  };

  const retornaStatusRadioGroup = valorAtual =>
    valorAtual === 2 && !todasAprovadas
      ? 0
      : valorAtual !== 2 && todasAprovadas
      ? 0
      : valorAtual;

  return (
    <Row>
      <Radio.Group
        onChange={onChange}
        value={retornaStatusRadioGroup(value)}
        name="radiogroup"
        defaultValue={0}
      >
        <S.OptionRadio disabled={!todasAprovadas} value={2}>
          Aprovado
        </S.OptionRadio>
        <S.OptionRadio disabled={todasAprovadas} value={3}>
          Bloqueado
        </S.OptionRadio>
        <S.OptionRadio disabled={todasAprovadas} value={4}>
          Insuficiência
        </S.OptionRadio>
      </Radio.Group>
    </Row>
  );
}
